import { FormattedRpServiceConfigurationAttribute } from "@idw-types/data/rp-service-configuration";
import { AXNUITextInput } from "@iddataweb/idw-common-ui/containers";
import commonStyles from "@styles/common.less";
import { AXNUIThemingLabelComponent } from "@containers/common/axnui-theming-preview-container/axnui-theming-label-component/axnui-theming-label-component";

type AXNUIThemingTextInputComponentProps = {
    attribute: FormattedRpServiceConfigurationAttribute;
    isRequired: boolean;
    label: string;
    placeholder: string;
};

export const AXNUIThemingTextInputComponent = (props: AXNUIThemingTextInputComponentProps) => {
    const { attribute, isRequired, label, placeholder } = props;
    
    return (
        <div className={commonStyles.axnuiPreviewInputContainer}>
            <AXNUIThemingLabelComponent
                    controlId={`attribute-input-${attribute.attributeType.id}`}
                    label={label}
                    isRequired={isRequired}
                />

            <AXNUITextInput
                controlId={attribute.attributeType.name}
                required={isRequired}
                disabled={false}
                readOnly={true}
                ariaLabel={label}
                placeholder={placeholder}
                value={undefined}
                title={null}
                onChange={() => { }}
                onBlur={() => { }}
            />
        </div>
    );
};